document.addEventListener('DOMContentLoaded', () => {
    const popup = document.querySelector('.popup');
    const popupContent = document.querySelector('.popup-content');
    const ingredientCards = document.querySelectorAll('.ingredient-card');
    const infoButton = document.querySelector('.info-button');
    const closePopupButton = document.querySelector('.close-popup');
    const overlay = document.querySelector('.overlay');
    const seeAllButton = document.querySelector('.see-all-button');
    const allIngredients = document.querySelector('.all-ingredients');
    const bodyElem = document.querySelector('body');
    /**
     * Opens the popup and scrolls to the specified card index.
     * @param {number} index - The index of the card to scroll to.
     */
    const openPopup = (index = 1) => {
      popup.classList.remove('hidden');
      overlay.style.display= "block";
      bodyElem.style.overflow = "hidden";
  
      // Add a slight delay to ensure the popup is rendered before scrolling
      setTimeout(() => {
        const targetCard = popupContent.querySelector(`.popup-card[data-index="${index}"]`);
        if (targetCard) {
          popupContent.scrollTo({
            left: targetCard.offsetLeft - 16,
            behavior: 'smooth',
          });
        }
      }, 100); // Delay ensures popup is fully rendered before scrolling
    };
  
    // Add click event listeners to ingredient cards
    ingredientCards.forEach(card => {
      card.addEventListener('click', () => {
        const index = card.getAttribute('data-index');
        openPopup(index);
      });
    });
  
    // Open popup and scroll to the first card when info button is clicked
    infoButton?.addEventListener('click', () => openPopup());
  
    // Close popup when close button is clicked
    closePopupButton?.addEventListener('click', () => {
      popup.classList.add('hidden');
      overlay.style.display= "none";
      bodyElem.style.overflow = "auto";
    });

    overlay?.addEventListener('click', () => {
        popup.classList.add('hidden');
        overlay.style.display= "none";
        bodyElem.style.overflow = "auto";
      });
  

  
    // Close popup if clicking outside the popup content
    popup?.addEventListener('click', (e) => {
      if (e.target === popup) {
        popup.classList.add('hidden');
      }
    });

    // Toggle the visibility of the ingredients section
    seeAllButton?.addEventListener("click", () => {
        allIngredients.classList.toggle("active");
      });
      // Set interval to change the SVG path stroke color to make it appear clickable
      let isColorChanged = false;
      if (infoButton){
        setInterval(() => {
          const svgPaths = infoButton.querySelectorAll('svg path'); // Select all paths inside the SVG
        
          svgPaths.forEach((path) => {
            path.style.stroke = isColorChanged ? '#05301e' : '#a9bd78'; // Toggle stroke color
          });
        
          isColorChanged = !isColorChanged; // Update the color change flag
        }, 1000);
      }

      document.querySelector(".product__content .product__block--accordion").style.borderTop = "1px solid rgb(5, 48, 30)";
      
  });


  
  